import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { formatDistanceToNow } from 'date-fns';

// Firebase
import { db, functions } from '../../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, onSnapshot, orderBy, startAfter, limit } from 'firebase/firestore';

import { connect } from 'react-redux';

// Actions
import { getRecent_Followers_By_Group, set_ShowBottomSpinner, clearUser, getUserById, clearPeople } from '../../actions/authActions';
import { toggleMessageModal } from '../../actions/navActions';

// Components - imported
import { Avatar } from '@material-ui/core';
import Spinner from '../../components/common/Spinner';
import DefaultAvatar from 'react-avatar';

// Icons
import CheckIcon from '@material-ui/icons/Check';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import MailIcon from '@material-ui/icons/Mail';

// Displays if the user is logged in AND has set up profile
const PeopleSection = ({ 
    group: {
        group,
        loading
    },
    auth: {
        people,
        no_more_users,
        show_bottom_spinner,
        last_page_doc,
        people_loading,
        modalUser,
        user
    },
    getRecent_Followers_By_Group,
    set_ShowBottomSpinner,
    clearUser, 
    getUserById,
    clearPeople,
    toggleMessageModal
}) => {
    // Users List
    const [userList, setUserList] = useState([]);
    const [gotUsers, setGotUsers] = useState(false);

    // Disable 'see more' users btn and show a loading state
    const [processing, setProcessing] = useState(false);

    useEffect(() => {


        if(!loading && group && !gotUsers) {
            clearPeople();
            getRecent_Followers_By_Group(group._id);
            setGotUsers(true);
        }
        

    }, [loading, group]);

    useEffect(() => {

        renderUserList();

    }, [people]);

    useEffect(() => {

        if(modalUser) {
            toggleMessageModal();
        }

    }, [modalUser]);

    // --- User Modal Stuff ---

    const handleUserClick = (user_obj) => {
        if(modalUser) {
            clearUser();
        } else {
            getUserById(user_obj._id);
        }
    }

    // Function to load more paginated people
    const loadMore = async (lastPage_doc) => {
        if(processing || !group) return;
        try {
            setProcessing(true);

            // Show spinner
            set_ShowBottomSpinner(true);

            // Fetch the next set of people
            await getRecent_Followers_By_Group(group._id, lastPage_doc);
            
        } catch (error) {
            console.log('Error: loading more people', error);
            set_ShowBottomSpinner(false);
        } finally {
            setProcessing(false);
        }
    }

    // --- END: Infinite Scroll

    const renderUserList = async () => {
        setUserList([]);

        if(people === null || people_loading) {
            setUserList([(
                <div className="no-rides">
                    <Spinner />
                </div>
            )])
        }
        else { 
            if(people.length > 0) {
                people.map(user_doc => {
                    setUserList(userList => [...userList, (
                        <div key={user_doc._id} className={(modalUser && (user_doc._id === modalUser._id)) ? "userTable__block active" : "userTable__block"}>
                            {/* User Avatar - left */}
                            <div className="userTable__avatar">
                                {user_doc.img ? (
                                    <Avatar src={user_doc.img} />
                                ) : (
                                    <DefaultAvatar name={`${user_doc.first_name} ${user_doc.last_name}`} />
                                )}
                            </div>

                            {/* Display the user's name & username */}
                            <div className="userTable__info">
                                <h3>
                                    {user_doc.first_name}{' '}{user_doc.last_name}
                                </h3>
                                <p>Joined {formatDistanceToNow(user_doc.date)} ago</p>
                            </div>

                            {/* Show if User Block has been clicked */}
                            {/* <div className="userTable__active">

                                Check if the current user is the same as the selected user
                                {modalUser && (user_doc._id === modalUser._id) && <CheckIcon />}
                            </div> */}
                            {/* Check if the current user is the same as the selected user */}
                            {!(user_doc?._id === user?._id) && (
                                <div style={{height: '100%', display: 'flex', alignItems: 'center', paddingRight: '10px'}}>
                                    <div onClick={() => handleUserClick(user_doc)} className='see_more_btn icon_18' style={{zIndex: 10}}>
                                        Message
                                        <div style={{width: '5px'}}></div>
                                        <MailIcon />
                                    </div>
                                </div>
                            )}

                            {/* Invisible overlay for catching mouse clicks around the 'Message' btn */}
                            <div 
                                onClick={() => window.location.href = `/user/${user_doc._id}`} 
                                style={{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, zIndex: 9}}
                            ></div>
                        </div>
                    )])
                }) 
            } else {
                setUserList(userList => [...userList, (
                    <div className="no-rides">
                        <h1>No new people</h1>
                    </div>
                )])
                
            }
        } 
    }

    // Render the component
    return (
        <div style={{padding: '16px 0', width: '100%'}}>
            <div style={{padding: '0 16px', color:'rgb(15, 20, 25)', marginBottom: '8px', fontWeight:'700', fontSize:'24px', lineHeight:'24px', overflowWrap:'break-word'}}>
                <span style={{fontSize: '1.125rem'}}>New to the group</span>
            </div>

            <div style={{padding: '0 16px', display: 'flex', alignItems: 'center', width: '100%', marginBottom: '1rem'}}>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                    <h5 style={{fontWeight: 500, fontSize: '14px', color: 'rgb(83, 100, 113)'}}>
                        Recent people who follow will appear here.
                    </h5>
                </div>
            </div>

            {userList}

            {/* See more btn */}
            {(people.length > 0 && !no_more_users) && (

                <div style={{width: '100%', padding: '16px', boxSizing: 'border-box'}}>
                    <div onClick={!processing ? () => loadMore(last_page_doc) : null} className='see_more_btn full_width'>
                        {!processing ? 'See more' : 'Processing...'}
                    </div>
                </div>
            )}
        </div>
    )
}

// Prop types for the component
PeopleSection.propTypes = {

    // Prop type validation for function to toggle the Authentication modal
    nav: PropTypes.object.isRequired,
    group: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    getRecent_Followers_By_Group: PropTypes.func.isRequired,
    set_ShowBottomSpinner: PropTypes.func.isRequired,
    clearUser: PropTypes.func.isRequired,
    getUserById: PropTypes.func.isRequired,
    clearPeople: PropTypes.func.isRequired,
    toggleMessageModal: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    nav: state.nav,
    auth: state.auth,
    group: state.group
})

export default connect(mapStateToProps, { 

    // Connecting actions from Redux to the component
    getRecent_Followers_By_Group,
    set_ShowBottomSpinner,
    clearUser,
    getUserById,
    clearPeople,
    toggleMessageModal
})(PeopleSection);
